// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { localhost as _localhost } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the localhost chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1337
 * Chain Name: Localhost
 * Default Block Explorer: Not specified
 * Default RPC URL: http://127.0.0.1:8545
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { localhost } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: localhost,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const localhost = createCommon({
	..._localhost,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
